export class ReportImageInfo {
  ControlName: string;
  ControlType: string;
  PropertyName: string;
  DataMember: string;
  OPath: string;
  Format: string;
  WidthInMM: number;
  HeightInMM: number;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
